import { useState, useCallback, useContext } from 'react';
import { useLocation } from "react-router-dom";
import { UserContext } from '../../UserContext.js';

import styles from './UpdateSubscriptionScreen.module.css';
import helpers from '../../helpers.js';

import ScreenHeader from "../ScreenHeader.js";
import Module from "../Module.js";
import Button from "../Button.js"
import Plans from "./Plans.js";
import TextInput from "../TextInput.js";


import PaymentTerms from "./PaymentTerms.js";
import ProductCounter from "./ProductCounter.js";
import Calculator from "./Calculator.js";

import pincharPlaceholder from "../../assets/images/pincharPlaceholder.png"


function UpdateSubscriptionScreen(props) {
  const {user, setUser} = useContext(UserContext);
  const location = useLocation();
  
  let isFromNextScreen = typeof location.state?.formData !== "undefined";
  let nextUseLocationFormData = location.state?.formData;
  let planData = location.state?.planData;

  const [addresses, setAddresses] = useState(location.state?.addresses);
  const [selectedProduct, setSelectedProduct] = useState(
    planData && planData.bagQuantities ? planData.bagQuantities.productType : "pinchar"
  );

  const [errorPromptVoucher, setErrorPromptVoucher] = useState("");
  const [successPromptVoucher, setSuccessPromptVoucher] = useState("");
  const [highlighedtInputVoucher, setHighlighedtInputVoucher] = useState("");

  // Initialize form data with plan data if available
  const getInitialFormData = () => {
    if (typeof location.state?.formData !== "undefined") {
      return nextUseLocationFormData;
    }
    
    // If coming from plan creation, auto-fill bag quantities
    if (planData && planData.bagQuantities) {
      return {
        pincharBags: planData.bagQuantities.pincharBags || 0,
        pelletcharBags: planData.bagQuantities.pelletcharBags || 0,
        paymentPlan: "",
        plan: "oneYear",
        voucherCode: "",
        voucherDiscount: 0,
        freeItems: 0,
        selectedPlan: "",
        voucherApplied: false,
        selectedPaymentTerm: "upfront",
        termsConditions: false
      };
    }
    
    // Default empty form
    return {
      pincharBags: 0,
      pelletcharBags: 0,
      paymentPlan: "",
      plan: "oneYear",
      voucherCode: "",
      voucherDiscount: 0,
      freeItems: 0,
      selectedPlan: "",
      voucherApplied: false,
      selectedPaymentTerm: "upfront",
      termsConditions: false
    };
  };

  const [formData, setFormData] = useState(getInitialFormData());

  const handleChange = async (formField, value) => {
     const updatedFormData = { ...formData, [formField]: value };

  let newFormData = updatedFormData;

  const shouldRecalculateVoucher =
    updatedFormData.voucherApplied &&
    (
      formField === "pincharBags" ||
      formField === "pelletcharBags" ||
      formField === "plan"
    );

  if (shouldRecalculateVoucher) {
    const orderTotal = calculateOrderTotal(updatedFormData);
    const voucherData = await fetchVoucherDiscount(updatedFormData.voucherCode, orderTotal);

    if (voucherData) {
      newFormData = {
        ...updatedFormData,
        voucherDiscount: voucherData.discount,
        freeItems: voucherData.freeItems,
      };

      // 👇 Update the success message based on new voucher data
      setSuccessPromptVoucher(`Voucher applied: ${voucherData.description}. You saved £${voucherData.discount.toFixed(2)}`);
      setErrorPromptVoucher(""); // optional: clear old error if any
    }
  }

  setFormData(newFormData);
  };

  // ✅ Handle product selection when checkbox is clicked
  const handleProductSelection = (productName) => {
    setSelectedProduct(productName.toLowerCase());
  };
  
  const updateBiocharQty = async (pincharBags, pelletcharBags) => {
      const newFormData = { ...formData, pincharBags, pelletcharBags };

  // Check if a voucher is applied
  if (formData.voucherApplied) {
    const newTotal = pincharBags * 599 + pelletcharBags * 599;
    const voucherData = await fetchVoucherDiscount(formData.voucherCode, newTotal);

    if (voucherData) {
      newFormData.voucherDiscount = voucherData.discount;
      newFormData.freeItems = voucherData.freeItems;
    }
  }

  setFormData(newFormData);
  };

  const calculatePlanDiscount = () => {
    console.log("PLAN: " + formData.plan);
    switch(formData.plan) {
      case "individual":
        return 0;
      case "oneYear":
        return(formData.pincharBags * 200 + formData.pelletcharBags * 200);
      case "twoYears":
        return(formData.pincharBags * 200 + formData.pelletcharBags * 200); //SWITCH BACK TO 300
      default:
        return 0;
    }
  }

  const calculateSupervisorDiscount = () => {
    // return Math.round((formData.pincharBags * 80 + formData.pelletcharBags * 80)/6);
    return
  }

  const renderHeader = (header, stepNumber, bgColor) => {
    return (
        <div className={styles.headerContainer}>
            <div className={helpers.clx(styles.hexagon, bgColor === "leaf" ? styles.hexagonLeaf : "")}>
                {stepNumber}
            </div>
            <div className={helpers.clx(styles.headerText, bgColor === "leaf" ? styles.headerTextLeaf : "")}>
              {header}
            </div>
        </div>
    );
  };

const calculateOrderTotal = (data = formData) => {
  let discount = 0;
  switch (data.plan) {
    case "oneYear":
      discount = 200;
      break;
    case "twoYears":
      discount = 200;
      break;
    default:
      discount = 0;
  }
  const pincharTotal = data.pincharBags * (599 - discount);
  const pelletcharTotal = data.pelletcharBags * (599 - discount);
  return pincharTotal + pelletcharTotal;
};

  const fetchVoucherDiscount = async (code, orderTotal) => {
  try {
    const res = await fetch(user.backEndURL + "/voucher/apply", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        voucherCode: code,
        userId: user.details.id,
        orderTotal: orderTotal
      })
    });

    const data = await res.json();
    if (data.success) return data.data;
        console.log("HELLO")

    console.log(data.data)
    throw new Error(data.message);
  } catch (err) {
    console.error("Voucher error:", err);
    return null;
  }
};

  const handleSubmitCode = async () => {
    try {
      const orderTotal = calculateOrderTotal();
      const voucherData = await fetchVoucherDiscount(formData.voucherCode, orderTotal);
 
      if (voucherData) {
        setFormData({
          ...formData,
          voucherDiscount: voucherData.discount,
          freeItems: voucherData.freeItems,
          voucherApplied: true
        });

        setErrorPromptVoucher("");
        setSuccessPromptVoucher(`Voucher applied: ${voucherData.description}. You saved £${(voucherData.discount).toFixed(2)}`);
      } else {
        helpers.errorPrompt("Invalid or expired voucher code", "voucherCode", setErrorPromptVoucher, setHighlighedtInputVoucher);
      }
    } catch (err) {
      console.log(err);
      helpers.errorPrompt(err.message, "voucherCode", setErrorPromptVoucher, setHighlighedtInputVoucher);
    }
  }

  console.log("HEREEWEEEE" + formData.voucherDiscount)
  return (
    <div className={helpers.clx("mainWhiteContainerContent", props.screenTransitioning ? "mainWhiteContainerContentHidden" : "")}>
          <ScreenHeader name={"Bulk Biochar Purchase"} content={"Ready to order? Get your biochar in just three steps: Choose how many bags you need, select a plan, and set up your payment."}/>
          <div className={"contentGrid"}>
            <Module icon={""}  spanColumn={18} spanRow={2} height={"100%"}>
            {renderHeader("How Much Biochar Do You Need?", 1)}
            <div className = {styles.planDescription}>
               Not sure how much biochar you need? Make a <a href="/zones" className={styles.link}> plan for your farm</a> or <a href="/support" className={styles.link}>reach out to our team </a>.
            </div>

              <div className={styles.productsContainer}>
                <div className={helpers.clx(styles.productContainer, selectedProduct === "pinchar" ? styles.productContainerSelected : "")}>
                  <ProductCounter selectedProduct={selectedProduct} fieldName={"pincharBags"} value={formData.pincharBags} handleChange={handleChange} handleProductSelection={handleProductSelection} name="PinChar" perBag="~ 300 kg/bag" icon={pincharPlaceholder}/>    
                </div>
                <div className={styles.separatorLine}/>
                <div className={helpers.clx(styles.productContainer, selectedProduct === "pelletchar" ? styles.productContainerSelected : "")}>
                  <ProductCounter selectedProduct={selectedProduct} fieldName={"pelletcharBags"} value={formData.pelletcharBags} handleChange={handleChange} handleProductSelection={handleProductSelection} name="PelletChar" perBag="~ 650 kg/bag" icon={pincharPlaceholder} disabled={true}/>    
                </div>
              </div>
           
            </Module>
            <Module background={"var(--leaf)"} spanColumn={6} spanRow={3} >
              {renderHeader("Storage & Delivery", 3, "leaf")}
              <div className={styles.storageDeliveryContent}>
                <div className={styles.storageDeliveryRow}>
                  <span className={styles.storageDeliveryIcon}>truck</span>
                    <div className={styles.weightText}>
                    ~ <span className={styles.storageDeliveryValue}>{Math.ceil((formData.pincharBags + formData.pelletcharBags) / 24)}</span>&nbsp;delivery
                    </div>
                </div>
                <div className={styles.storageDeliverySeparatorLine}/>
                <div className={styles.storageDeliveryRow}>
                  <span className={styles.storageDeliveryIcon}>cube</span>
                    <div className={styles.weightText}>
                      Each bag requires <span className={styles.weightAmount}> ~ 1 m</span><span className={styles.weightAmountExp}>2</span>  of floor space for storage 
                    </div>
                </div>
                <div className={styles.storageDeliverySeparatorLine}/>
                <div className={styles.storageDeliveryRow}>
                  <span className={styles.storageDeliveryIcon}>pound-sign</span>
                    <div className={styles.weightText}>
                      Get <span className={styles.weightAmount}>£ 20 </span> back for each bag successfully logged in the BBB app
                    </div>
                </div>
              </div>
            </Module>  
           
            <Module spanColumn={18} spanRow={6} height={"100%"}>
            {renderHeader("Select Option", 2)}

              <div className = {styles.planDescription}>
              Choose between a one-time purchase or long-term plans with added benefits.
              </div>
              <Plans handleChange={handleChange} plan={formData.plan} selected={formData.plan}/>
            </Module>
            <Module spanColumn={6} spanRow={2}>
              {renderHeader("Voucher Code", 4)}
              <div className={styles.voucherContentContainer}>
                <TextInput 
                  name="Voucher Code" 
                  iconName="tags"
                  value={formData.voucherCode} 
                  onChange={(value) => handleChange("voucherCode", value)} 
                  labelStyle="top" 
                  placeholder="Enter Code"
                />
                <Button name={"Enter"} disabled={formData.voucherCode?.length < 1 || formData.voucherApplied ? true : false} onPress={handleSubmitCode}/>
                <div className={helpers.clx("errorPrompt", formData.voucherApplied ? styles.successPrompt : "")}>
                  {successPromptVoucher !== "" ? successPromptVoucher : errorPromptVoucher}

                </div>
              </div>
             
            </Module>
            
            <Module name={"Price Breakdown"}spanColumn={6} spanRow={3} >
              <div className={styles.invoiceContainer}>
                <div className={styles.invoiceTable}>
                  <div className={styles.invoiceRow}>
                    <div className={styles.invoiceItem}>PinChar</div>
                    <div className={styles.invoicePrice}>£ {(formData.pincharBags * 599).toFixed(2)}</div>
                  </div>
                  <div className={helpers.clx(styles.invoiceRow, styles.invoiceRowWhite)}>
                    <div className={styles.invoiceItem}>PelletChar</div>
                    <div className={styles.invoicePrice}>£ {(formData.pelletcharBags * 599).toFixed(2)}</div>
                  </div>
                  <div className={styles.invoiceRow}>
                    <div className={styles.invoiceItem}>Contract Discount</div>
                    <div className={styles.invoicePrice}> £ {calculatePlanDiscount().toFixed(2)}</div>
                  </div>
                   <div className={helpers.clx(styles.invoiceRow, styles.invoiceRowWhite)}>
                    <div className={styles.invoiceItem}>Voucher Discount</div>
                    <div className={styles.invoicePrice}> £ {(formData.voucherDiscount).toFixed(2)}</div>
                  </div>
                  {/* <div className={styles.invoiceRow}>
                    <div className={styles.invoiceItem}>Voucher</div>
                    <div className={styles.invoicePrice}> £ {formData.voucherDiscount}</div>
                  </div> */}
                  <div className={styles.invoiceLine}/>
                  <div className={helpers.clx(styles.invoiceRow, styles.invoiceRowBlack)}>
                    <div className={styles.invoiceItemBlack}>TOTAL</div>
                    <div className={styles.invoicePriceBlack}>£ {((formData.pelletcharBags * 599 + formData.pincharBags * 599) - calculatePlanDiscount()  - formData.voucherDiscount).toFixed(2)}</div>
                  </div>
                </div>
                <Button name="Next" onPress={() => props.goToScreen("review-subscription", {formData: formData, addresses: addresses})} color="Grass" disabled={formData.plan === "" || formData.pincharBags === 0 && formData.pelletcharBags === 0 ? true : false}/>
              </div>
              
            </Module>         
            {/* <Module name={"Select Payment Terms"} spanColumn={18} spanRow={1} height={"100%"}>
              <div>
              Depending on the payment plan you select, you may benefit from a discount. Your payment plan will not affect the frequency of your deliveries. For first-time customers, first invoice will be sent upon order confirmation.
              </div>
              <PaymentTerms handleChange={handleChange} selectedPaymentTerm={formData.selectedPaymentTerm} />
            </Module> */}
          </div>
    </div>
  );
}

export default UpdateSubscriptionScreen;
